import Nullstack from 'nullstack';
export default function IconExchange({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-exchange",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"
  }), " ");
}